<template>
  <transition name="fade" >
    <div class="article-dialog" v-if="!close" @click="closeDialog"  >
      <div class="article-main">
        <div class="article-wrapper"  @click.stop.prevent>
          <div class="article-header">{{article.title}}</div>
          <div class="article-banner" v-if="article.thumb">
            <img :src="article.thumb"/>
          </div>
          <div class="article-body" v-html="article.content">
          </div>
        </div>
        
      </div>
      <img src="../assets/training-dialog-btn-close.png" class="btn-close" @click="closeDialog"/>
    </div>
  </transition>
  
</template>

<script>
export default {
  name:'YinduArticle',
  data(){
    return {
     
    }
  },
  methods:{
    closeDialog(){
      // this.closed = true;
      this.$emit("closeDialog");
    }
  },
  props:{
    close:{
      type: Boolean,
      default: false
    },
    article: {
      type: Object,
      default: ()=>{
        return {title:'',thumb:'',content:''};
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../common/common.scss";

  .fade-enter , 
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s linear;
  }
  .article-dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.85);
    left: 0;
    top: 0;
    transform: translate3d(0,0,0);
    z-index: 10000;
    cursor: pointer;
    overflow: hidden;
  }
  .article-main {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
  .article-wrapper{
    background: #fff;
    padding: 18px 11px;
    min-height: 100%;
    width: px2percent(438);
    margin: 0 auto;
    box-sizing: border-box;
    font-size: 16px;
    color: #9d9d9d;
    cursor: default;
  }
  .article-header {
    font-size: 24px;
    color: #000;
    margin-bottom: 14px;
  }
  .article-banner img{
    width: 100%;
  }
  .btn-close {
    position: absolute;
    right: 0;
    top:0;
    cursor: pointer;
  }
</style>
